// billingService.js
import axiosInstance from './axiosInstance';

export const billingService = {
    // Get survey response pricing
    getSurveyResponsePricing: async () => {
        const response = await axiosInstance.get('/admin/billing-config/survey-response-pricing');
        return response.data;
    },

    // Update survey response pricing
    updateResponsePricing: async (price) => {
        const response = await axiosInstance.put('/admin/billing-config/update-response-pricing', null, {
            params: { price }
        });
        return response.data;
    },
    getSurveyPricingConfig: async () => {
        const response = await axiosInstance.get('/admin/billing-config/survey-pricing');
        return response.data;
    },

    // Calculate survey price based on parameters
    calculateSurveyPrice: async (data) => {
        const response = await axiosInstance.post('/admin/billing-config/calculate-price', data);
        return response.data;
    },
    // Get all survey question tiers
    getAllSurveyQuestionTiers: async () => {
        const response = await axiosInstance.get('/admin/billing-config/all-survey-question-tiers');
        return response.data;
    },

    // Add new question tier
    addQuestionTier: async (data) => {
        const response = await axiosInstance.post('/admin/billing-config/add-question-tiers/add', data);
        return response.data;
    },

    // Update question tier
    updateQuestionTier: async (id, data) => {
        const response = await axiosInstance.patch(`/admin/billing-config/update-question-tiers/${id}`, data);
        return response.data;
    },

    // Delete question tier
    deleteQuestionTier: async (id) => {
        const response = await axiosInstance.delete(`/admin/billing-config/delete-question-tiers/${id}`);
        return response.data;
    },

    // Get all survey criteria
    getAllSurveyCriteria: async () => {
        const response = await axiosInstance.get('/admin/billing-config/all-survey-criteria');
        return response.data;
    },

    // Update survey criteria
    updateSurveyCriteria: async (id, data) => {
        const response = await axiosInstance.patch(`/admin/billing-config/update-criteria/${id}`, data);
        return response.data;
    },

    // Add new survey criteria
    addSurveyCriteria: async (data) => {
        const response = await axiosInstance.post('/admin/billing-config/add-criteria', data);
        return response.data;
    },

    // Delete survey criteria
    deleteSurveyCriteria: async (id) => {
        const response = await axiosInstance.delete(`/admin/billing-config/delete-criteria/${id}`);
        return response.data;
    },

    // Get billing statistics
    getBillingStats: async () => {
        const response = await axiosInstance.get('/admin/billing-config/stats');
        return response.data;
    }
};
